"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("HubStyleTokens/colors");

var _Constants = require("../../Constants");

var _AvatarContentHolder = _interopRequireDefault(require("./AvatarContentHolder"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SVGIcon = _interopRequireDefault(require("./SVGIcon"));

var SocialBadgeWrapper = (0, _styledComponents.default)('div').withConfig({
  displayName: "SocialBadge__SocialBadgeWrapper",
  componentId: "sc-11m5oz4-0"
})(["align-items:center;border-radius:50%;bottom:-1%;color:", ";display:flex;font-family:sans-serif;font-size:600%;justify-content:center;position:absolute;right:-16%;user-select:none;width:64%;"], _colors.OLAF);

var SocialBadge = function SocialBadge(props) {
  var socialNetwork = props.socialNetwork;
  return _react.default.createElement(SocialBadgeWrapper, null, _react.default.createElement(_AvatarContentHolder.default, null, _react.default.createElement(_SVGIcon.default, {
    wrapperProps: {
      style: {
        backgroundColor: _Constants.SOCIAL_MAP[socialNetwork].color
      }
    },
    y: "70",
    icon: _Constants.SOCIAL_MAP[socialNetwork].icon
  })));
};

SocialBadge.propTypes = {
  socialNetwork: _propTypes.default.oneOf(Object.keys(_Constants.SOCIAL_MAP))
};
var _default = SocialBadge;
exports.default = _default;
module.exports = exports.default;